import { HostListener, Injectable } from "@angular/core";
import { DGDrawingServiceGlobal } from "./DrawingService";

@Injectable({
  providedIn: "root"
})

export class ResizeService
{

  public constructor(){

  }

  public resizeAction(width:number, height:number)
  {
    console.log({ width: width, height: height });
    DGDrawingServiceGlobal.drawingService().chart.chart.applyOptions({ width: width-20, height: height });
    setTimeout(v=>{
 //     DGDrawingServiceGlobal.drawingService().selectRangeInit()
    },100);
  }



}
